<template>
    <div class="bg-white p-6 shadow-md space-y-6">
        <h2 class="text-xl font-semibold text-gray-800 flex items-center">
            <span class="mr-2">📊</span>
            GPA Rankings by program
        </h2>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <!-- Top 3 -->
            <div>
                <h3 class="text-lg font-semibold text-deep-green mb-3 flex items-center">
                    <span class="mr-2">📈</span> Programs with Highest GPA
                </h3>
                <ul class="space-y-2">
                    <li v-for="(item, index) in top3" :key="'top' + index"
                        class="flex justify-between items-center bg-soft-green border border-dark-soft-green px-4 py-3 hover:shadow-md transition">
                        <span class="font-medium text-gray-800 truncate">{{ item.program_name }}</span>
                        <span class="text-deep-green font-semibold">{{ item.average_gpa.toFixed(2) }}</span>
                    </li>
                </ul>
            </div>

            <!-- Bottom 3 -->
            <div>
                <h3 class="text-lg font-semibold text-deep-red mb-3 flex items-center">
                    <span class="mr-2">📉</span> Programs with Lowest GPA
                </h3>
                <ul class="space-y-2">
                    <li v-for="(item, index) in bottom3" :key="'bottom' + index"
                        class="flex justify-between items-center bg-soft-red border border-dark-soft-red px-4 py-3 hover:shadow-md transition">
                        <span class="font-medium text-gray-800 truncate">{{ item.program_name }}</span>
                        <span class="text-deep-red font-semibold">{{ item.average_gpa.toFixed(2) }}</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TopBottomGPA",
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    computed: {
        sortedByGPA() {
            return [...this.data].sort((a, b) => b.average_gpa - a.average_gpa);
        },
        top3() {
            return this.sortedByGPA.slice(0, 3);
        },
        // bottom3() {
        //     return this.sortedByGPA.slice(-3).reverse();
        // }
        bottom3() {
            // Filter out programs with average_gpa 0
            const filtered = this.data.filter(item => item.average_gpa > 0);
            return [...filtered].sort((a, b) => a.average_gpa - b.average_gpa).slice(0, 3);
        },
    }
};
</script>

<style scoped>
/* Optional: Add hover effects or transitions */
</style>
